// extracted by mini-css-extract-plugin
export var heading = "CodeEmbedModule-module--heading--C5XT_";